import React from 'react';
import curry from 'lodash/fp/curry';
import format from 'date-fns/format';
import Text, { Large, Small } from '@dbk/ui-text';
import SimpleDate from '../components/common/date';
import datesAreEqual from 'date-fns/is_equal';

export const addDays = curry((n, date) => {
  const utc = new Date(Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate() + n,
    date.getHours(),
    date.getMinutes(),
    date.getSeconds()
  ));
  return new Date(
    utc.getUTCFullYear(),
    utc.getUTCMonth(),
    utc.getUTCDate(),
    utc.getUTCHours(),
    utc.getUTCMinutes(),
    utc.getUTCSeconds()
  );
});

export const addMonths = curry((n, date) => {
  const utc = new Date(Date.UTC(
    date.getFullYear(),
    date.getMonth() + n,
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds()
  ));
  return new Date(
    utc.getUTCFullYear(),
    utc.getUTCMonth(),
    utc.getUTCDate(),
    utc.getUTCHours(),
    utc.getUTCMinutes(),
    utc.getUTCSeconds()
  );
});



export const dateDiff = curry((startDate, endDate) => {
  var _MS_PER_DAY = 1000 * 60 * 60 * 24;


  var utc1 = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
  var utc2 = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

  return Math.floor((utc2 - utc1) / _MS_PER_DAY);


});

export const ymd = date => format(date, 'YYYY-MM-DD')

export const currentDateText = (fromDate, toDate,messages) =>{
  if (datesAreEqual(fromDate, toDate)) {
    return (
      <Text size="large" secondary> {messages['app.common.show']} <SimpleDate value={fromDate} month='long'/> </Text>
    );
  }
  return (
    <Text size="large" secondary> {messages['app.common.show']} {<SimpleDate value={fromDate} month='long'/>} {messages['app.common.to']} {<SimpleDate value={toDate} month='long'/>} </Text>
  );
}
